import { ENTITY_TYPES } from 'containers/App/modules/entities/entities.constants';
import { createNewEntitySlice } from 'containers/App/modules/entities/entities.utils';
import { parseFetchAllRequest } from './events.parsers';

const eventsEntitySlice = createNewEntitySlice({
	name: ENTITY_TYPES.EVENTS,
	parseFetchAllRequest
});

const { reducer, actions, selectors } = eventsEntitySlice;

const {
	fetchAll:        fetchEvents,
	fetchAllPending: fetchEventsPending,
	fetchAllSuccess: fetchEventsSuccess,
	fetchAllFailure: fetchEventsFailure,
} = actions;

export const eventsEntityActions = {
	fetchEvents,
	fetchEventsPending,
	fetchEventsSuccess,
	fetchEventsFailure,
};

const {
	selectAll:             selectEvents,
	selectFetchAllPending: selectEventsPending,
} = selectors;

export const eventsEntitySelectors = {
	selectEvents,
	selectEventsPending,
};

export default reducer;
